import Heading from '@commons/Heading/Heading';

/**
 * Blurb title component with configurable heading level.
 */
export default function BlurbTitle({ level = 3, visualLevel = undefined, children, className = '' }) {
  if (!children) return null;

  return (
    <Heading level={level} visualLevel={visualLevel} className={`Blurb__title ${className}`}>
      {children}
    </Heading>
  );
}
